
import React, { useEffect } from "react";
import { AlertCircle, RefreshCw, Wifi } from "lucide-react";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";

interface ErrorStateProps {
  error: string;
  onRetry: () => void;
  is503Error?: boolean;
}

const ErrorState: React.FC<ErrorStateProps> = ({ error, onRetry, is503Error = false }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Se não é erro 503 e apareceu "Erro ao Carregar Feed", redirecionar para logout
    if (!is503Error) {
      const handleAutoLogout = () => {
        console.log('Erro no feed detectado, redirecionando para logout...');
        navigate('/main/logout');
      };

      // Pequeno delay para mostrar a mensagem de erro antes do logout
      const timer = setTimeout(handleAutoLogout, 2000);
      
      return () => clearTimeout(timer);
    }
  }, [is503Error, navigate]);
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="bg-red-500/10 p-6 rounded-full mb-6">
        {is503Error ? (
          <Wifi className="h-12 w-12 text-red-400" />
        ) : (
          <AlertCircle className="h-12 w-12 text-red-400" />
        )}
      </div>
      
      <h3 className="text-xl font-semibold text-white mb-2">
        {is503Error ? "Serviço Temporariamente Indisponível" : "Erro ao Carregar Feed"}
      </h3>
      
      <p className="text-white/60 mb-6 max-w-md">
        {is503Error 
          ? "Nossos serviços estão temporariamente indisponíveis. Estamos trabalhando para resolver isso o mais rápido possível."
          : error
        }
      </p>
      
      <Button
        onClick={onRetry}
        variant="outline"
        className="bg-white/10 border-white/20 hover:bg-white/20 text-white"
      >
        <RefreshCw className="h-4 w-4 mr-2" />
        {is503Error ? "Tentar Novamente" : "Recarregar"}
      </Button>
      
      {is503Error && (
        <p className="text-white/40 text-sm mt-4">
          Se o problema persistir, tente novamente em alguns minutos
        </p>
      )}
    </div>
  );
};

export default ErrorState;
